import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const FocusOccasionUploadRequest = (filePath, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/FocusOccasionUpload`,
	params: { filePath, userName, userId }
});

export const DownloadTemplateRequest = (userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/FocusOccasionDownloadTemplate`,
	params: { userName, userId }
});
